import { MYDATA } from "../../actions/dashboard/";

const INITIALVALUES = {
  dashboard_mydata: []
};

export default function(state = INITIALVALUES, action) {
  switch (action.type) {
    case MYDATA:
      return [action.payload, ...state];
    default:
  }

  return state;
}
